export default function initForumReplyForm(): void {
    document.querySelectorAll<HTMLElement>('.js-forum-reply-files').forEach(wrapper => {
        const formCol  = wrapper.closest('.form-col');
        const addBtn   = formCol?.querySelector<HTMLElement>('.js-forum-reply-file-add');
        const template = formCol?.querySelector<HTMLTemplateElement>('.js-forum-reply-file-template');
        const DEFAULT_LABEL = 'Choisir le fichier';

        function bindRow(row: HTMLElement): void {
            const input  = row.querySelector<HTMLInputElement>('.forum-reply-file-input');
            const label  = row.querySelector<HTMLElement>('.js-forum-reply-file-text');
            const remove = row.querySelector<HTMLElement>('.js-forum-reply-file-remove');

            input?.addEventListener('change', () => {
                if (label) label.textContent = input.files?.[0]?.name ?? DEFAULT_LABEL;
            });

            remove?.addEventListener('click', () => row.remove());
        }

        addBtn?.addEventListener('click', () => {
            if (!template) return;
            const row = (template.content.cloneNode(true) as DocumentFragment).firstElementChild as HTMLElement;
            wrapper.appendChild(row);
            bindRow(row);
        });
    });
}
